import React, { Component } from 'react';

import PlaceRolesModel from './PlaceRolesModel';

import { Select } from 'antd';
const Option = Select.Option;

class ParkinglocationSelect extends Component {

  state = {
    children: []
  }

  componentWillMount() {            
    PlaceRolesModel.getAll()
    .then(data => {     
      var children = [];   
      data.map((child, key) => {
      return children.push(<Option key={child.id}>{child.code + ' - ' + child.name}</Option>);
      });
      this.setState({
        children: children
      });
    });
  }

  render() {    
    return (    
      <Select
        size="default"
        showSearch
        placeholder={this.props.placeholder ? this.props.placeholder : 'Zvolte roli'}
        optionFilterProp="children"
        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0} 
        onChange={(value) => { this.props.onChange(value) }}        
        {...this.props}>
          {this.state.children}
      </Select>
    );
  }
}

export default ParkinglocationSelect;


// WEBPACK FOOTER //
// ./src/components/PlaceRolesSelect.js